export default {
  /* This section was auto-generated by bzs-helper ($Properties$) */
  address: { field: 'address', fieldType: 'text' },
  allReportEmails: { field: 'allReportEmails', fieldType: 'text' },
  attention: { field: 'attention', fieldType: 'text' },
  badReportEmails: { field: 'badReportEmails', fieldType: 'text' },
  comments: { field: 'comments', fieldType: 'text' },
  createdOn: { field: 'createdOn', fieldType: 'date' },
  customerCode: { field: 'customerCode', fieldType: 'text' },
  customerId: { field: 'customerID', fieldType: 'numeric', required: true },
  customerName: { field: 'customerName', fieldType: 'text', label: 'Customer Name' },
  customerSearchField: { field: 'customerSearchField', fieldType: 'text' },
  customerThirdParty: { field: 'customerThirdParty', fieldType: 'text' },
  email: { field: 'email', fieldType: 'text', type: 'email' },
  fax: { field: 'fax', fieldType: 'text' },
  goodReportEmails: { field: 'goodReportEmails', fieldType: 'text' },
  modifiedOn: { field: 'modifiedOn', fieldType: 'date' },
  phone: { field: 'phone', fieldType: 'text' }
};
